import { objectWithoutProperties as _objectWithoutProperties } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { tokens } from '@everfi/design-system';
import { GenericLabel } from '../../generic-label/component.js';
import { formatClassName as _formatClassName } from '../../../utils/formatClassName.js';
import { Layout } from '../../../core/components/Layout/component.js';
import { Label } from '../../../core/components/Label/component.js';
var _excluded = ["hasMedia", "chakra"];

var CardSpecialLabel = function CardSpecialLabel(props) {
  var hasMedia = props.hasMedia,
      _props$chakra = props.chakra,
      chakra = _props$chakra === void 0 ? 'on' : _props$chakra,
      rest = _objectWithoutProperties(props, _excluded);

  var specialLabelClasses = _formatClassName(["card-special-label", "card-special-label-".concat(rest.type), {
    'no-media': !hasMedia
  }]);

  return chakra === 'on' ?
  /*#__PURE__*/
  // TODO use Core tags when available
  React.createElement(Layout, {
    position: hasMedia ? 'absolute' : 'static',
    background: "white",
    borderRightRadius: "16px",
    border: "".concat(tokens.BorderWidthXs, " solid ").concat(tokens.ColorsGrey200),
    padding: "".concat(tokens.SpacingBaseXs, " ").concat(tokens.SpacingBaseMd),
    mt: tokens.SpacingBaseMd,
    width: "fit-content"
  }, /*#__PURE__*/React.createElement(Label, {
    label: {
      type: 'iconLeft',
      options: {
        text: rest.label,
        icon: {
          iconName: rest.icon,
          color: rest.iconColor
        }
      }
    }
  })) : /*#__PURE__*/React.createElement("div", {
    className: specialLabelClasses
  }, /*#__PURE__*/React.createElement(GenericLabel, rest));
};

export { CardSpecialLabel };